// extracted by mini-css-extract-plugin
export default {"loader_container":"Loading_loader_container__Oig-2","loader":"Loading_loader__SSdZ4","rotate":"Loading_rotate__BXCAB","loaderreverse":"Loading_loaderreverse__w6AMd"};